import { takeLatest, put, all, call } from 'redux-saga/effects';

// SERVICES
import { PATH_AAC_API } from 'services/rotasp/path';
import { ApiResponse, putApi } from 'services/rotasp/api';

// STORE
import { ReducerActionRotaSP } from 'store/modules/types';

// ACTIONS
import {
	encerrarAtendimentoSuccess,
	encerrarAtendimentoFailure,
} from './actions';

// TYPES
import { Types, RequestEncerrarAtendimento } from './types';

function* encerrarAtendimentoRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: RequestEncerrarAtendimento } = request;

	const response: ApiResponse = yield call(
		putApi,
		token || '',
		PATH_AAC_API,
		`central-liberacao/atendimentos/${payload.idIdentificacao}/encerramento`,
		{},
	);

	if (response.status === 200) {
		yield put(encerrarAtendimentoSuccess(response.data));
	} else if (response.error) {
		yield put(encerrarAtendimentoFailure());
	}
}

export default all([
	takeLatest(Types.ENCERRAR_ATENDIMENTO_REQUEST, encerrarAtendimentoRequest),
]);
